import script from "./DropdownItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownItem.vue?vue&type=script&setup=true&lang=js"

import "./DropdownItem.vue?vue&type=style&index=0&id=7901e488&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7901e488"]])

export default __exports__